import React, { useState, useRef } from 'react';
import Select from 'react-select';
import { IconLoader } from 'common/IconLoader';
import Label from 'components/shared/Label';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import './CustomSelectField.css';

const customStyles = {
  option: (provided, { data, isFocused, isSelected }) => ({
    ...provided,
    color: 'var(--ibmsTextColor_1)',
    backgroundColor: isSelected ? 'var(--bermudaBlue-5)' : isFocused ? 'var(--bermudaBlue-6)' : 'inherit',
    maxWidth: '100%',
    top: '-20px',
    fontSize: '13px',
    overflow: 'hidden',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '32px'
  }),
  dropdownIndicator: (base, { isDisabled }) => ({
    ...base,
    color: isDisabled ? 'inherit' : 'var(--bermudaBlue)'
  }),
  valueContainer: (base, { hasValue, isDisabled }) => ({
    ...base,
    color: 'var(--ibmsTextColor_1)',
    fontWeight: hasValue && isDisabled ? 500 : 'inherit'
  }),
  menuPortal: (base) => ({ ...base, zIndex: 99999 })
};

function CustomSelectField({
  name,
  label,
  options,
  placeholder,
  value = undefined,
  disabled,
  isSearchable = false,
  isClearable = false,
  isIconsSupport = false,
  menuPlacement = 'auto',
  errorMessage,
  onChange,
  setErrors
}) {
  const [searchText, setSearchText] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const selectRef = useRef();

  const filterOptions = (candidate, input) => {
    if (isClearable) {
      setSearchText(input);
    }
    if (input) {
      return candidate.value.toLowerCase().includes(input.toLowerCase());
    }
    return true;
  };

  const handlerChange = (e) => {
    if (onChange) {
      onChange(e);
    }

    if (setErrors) {
      setErrors((state) => ({ ...state, [name]: undefined }));
    }
  };

  const noOptionsMessage = () => <div style={{ fontSize: '12px' }}>No options</div>;

  const onMenuOpen = () => setIsMenuOpen(true);

  const onMenuClose = () => setIsMenuOpen(false);

  return (
    <div className="CustomSelectField_Wrapper" data-testid="CustomSelectField_Wrapper">
      <Label name={name} text={label} />

      <Select
        className="react-select-container"
        classNamePrefix={!errorMessage ? 'react-select' : 'react-select-error'}
        ref={selectRef}
        name={name}
        isDisabled={disabled}
        isSearchable={isSearchable}
        value={value}
        options={options}
        filterOption={filterOptions}
        placeholder={placeholder}
        components={{ IndicatorSeparator: () => null }}
        onChange={handlerChange}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        formatOptionLabel={(data) => {
          if (isIconsSupport) {
            return <img src={data.label} width="7" alt={data.value} />;
          }
          return <span dangerouslySetInnerHTML={{ __html: data.label }} />;
        }}
        styles={customStyles}
        menuPlacement={menuPlacement}
        menuPortalTarget={document.body}
        noOptionsMessage={noOptionsMessage}
        openMenuOnFocus={true}
      />

      {((isClearable && value) || searchText.length > 0) && (
        <div className="CustomSelectField_Wrapper_Clear_Icon" onClick={() => selectRef.current.clearValue()}>
          <SvgAF img={IconLoader.icon_section_close} hover={IconLoader.icon_section_close_hover} />
        </div>
      )}

      <div className="InputField_Custom_ErrorMessage">{errorMessage && !isMenuOpen && <span>{errorMessage}</span>}</div>
    </div>
  );
}

export default CustomSelectField;
